import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <p>
        &copy; {year} Micro24 Energy. All rights reserved. | Built with
        Node.js &amp; React
      </p>
      <p style={{ fontSize: '0.75rem', marginTop: '0.5rem' }}>
        Sources:&nbsp;
        <a
          href="https://www.fortunebusinessinsights.com/fuel-additives-market-102913"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fuel additives market growth report【605170693125270†L115-L118】
        </a>
        ,&nbsp;
        <a
          href="https://www.cadencepetroleum.com/product/fuel-additives/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Why fuel additives matter【62368256257082†L149-L154】
        </a>
        .
      </p>
    </footer>
  );
};

export default Footer;